import Image from 'next/legacy/image'
import React from 'react'

const ImageGalleryVideoThumbnail = ({ src, title }) => {
  return (
    <>
      {src ? (
        <div className="video-thumb-wrapper">
          <div className="video-thumb"></div>
          <Image
            src={src}
            height={100}
            width={100}
            className="rounded-[6px]"
            title={title}
          />
        </div>
      ) : null}
    </>
  )
}

export const ProductImageGalleryVideoThumbnail = React.memo(
  ImageGalleryVideoThumbnail,
  (prevProps, nextProps) => prevProps.src === nextProps.src
)
